module.exports = __webpack_public_path__ + "img/microservices-sqs.ccd56c8d.svg";